import gql from 'graphql-tag';

export const addUserToWorkOrderComments = gql`
  mutation AddUserToWorkOrderComments($serviceRequestId: String!) {
    addUserToWorkOrderComments(serviceRequestId: $serviceRequestId)
  }
`;
